import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	loading: false,
	list: [],
};

const permissionSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setPermissionsData: (state, action) => {
			const { data } = action.payload;
			state.list = data || [];
		},
		setLoadingPermissions: (state, action) => {
			state.loading = action.payload;
		},
		setClearPermission: (state) => {
			state.data = [];
		},
	},
});

export const { setPermissionsData, setLoadingPermissions, setClearPermission } =
	permissionSlice.actions;

export default permissionSlice.reducer;
